import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {CompetitorContainerController} from "../competitor-container.controller";
import React from "react";
import {ENTITY_MEGA_HEADER} from "../../../apps/website/modules/entity-mega-header-module/entity-mega-header-module.consts";
import {EntityMegaHeaderModuleAsync} from "../../../apps/website/modules/entity-mega-header-module/components/entity-mega-header-module.async";
import {NAVIGATION_TABS_CONTEXT} from "../../../core/app/consts";
import {Breadcrumbs} from "../../../core/components/breadcrumbs/breadcrumbs";
import {CompetitorContainerDescriptionHeader} from "./competitor-container.description-header";
import {CompetitorContainerExternalAd} from "./competitor-container.external-ad";
import {SkyScrapperWrapper} from "../../../core/components/sky-scrapper/sky-scrapper.wrapper";
import {CompetitorContainerContent} from "./competitor-container.content";
import {SKY_SCRAPPER_OFFSET} from "../../../core/consts";

export class CompetitorContainerComponentProps extends BaseModuleProps {}

export const CompetitorContainerComponent = ({controller}) => {
  const {state} = controller;
  const {page, competitorViewModel, descriptionHeader, hasBreadcrumbs, shouldRenderAdsBorders} = state;

  const megaHeaderProps = {
    page,
    descriptionHeader,
    entity: competitorViewModel,
    entityType: ENTITY_MEGA_HEADER.ENTITY_TYPES.competitor,
    tabsContext: NAVIGATION_TABS_CONTEXT.competitor,
  }

  const breadcrumbsProps = {
    controller,
    visible: true,
    hasData: hasBreadcrumbs
  }

  return (
    <>
      <Breadcrumbs {...breadcrumbsProps}/>
      <EntityMegaHeaderModuleAsync {...megaHeaderProps}/>
      <CompetitorContainerDescriptionHeader controller={controller}/>
      <CompetitorContainerExternalAd controller={controller}/>
      {
        shouldRenderAdsBorders ? <SkyScrapperWrapper controller={controller} top={SKY_SCRAPPER_OFFSET.entityPage}>
          <CompetitorContainerContent controller={controller} shouldRenderAdsBorders={shouldRenderAdsBorders}/>
        </SkyScrapperWrapper> : <CompetitorContainerContent controller={controller}/>
      }
    </>
  )
}

const settings: ComposeSettings = {
  component: CompetitorContainerComponent,
  propsType: CompetitorContainerComponentProps,
  controllerType: CompetitorContainerController,

  useMetadata: true,
  filterRoute: true,
  observe: true,
  createModule: true,
}

export const CompetitorContainer = Compose(settings);

export default CompetitorContainer;
